export default "__VITE_ASSET__01c845c3__"